import React, { useEffect, useState } from "react";
import {
  Filter,
  FloatRight,
  ListView,
  PagesHeader,
} from "../../components/Mode";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Page from "../../components/Common/Page";
import { getModeList } from "../../appRedux/actions/mode";

const ModeList = () => {
  const dispatch = useDispatch();
  const [initialFetchComplete, setInitialFetchComplete] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [viewStatus, setViewStatus] = useState("listView"); //"listView", "gridView"
  const modeList = useSelector((state) => state.mode.modeList);
  console.log({ modeList });

  useEffect(() => {
    dispatch(getModeList({ page: 1, size: 10 })).then(() => {
      setInitialFetchComplete(true);
    });
  }, [dispatch]);
  return (
    <Page title="Mode">
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <PagesHeader
            pageTitle={"Mode List"}
            homePageUrl="/"
            homePageText="Dashboard"
            // innerPageUrl={""}
            // innerPageText={""}
            activePageText={"Mode"}
            floatRight={
              <FloatRight
                viewStatus={viewStatus}
                onChange={(status) => setViewStatus(status)}
              />
            }
          />
          {/* /Page Header */}
          <Filter {...{ initialFetchComplete, searchText, setSearchText }} />
          {/* <EmployeeListFilter /> */}

          <div className="card">
            <div className="card-body">
              <ListView {...{ searchText }} />
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </Page>
  );
};

export default ModeList;
